var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0087 3.22882C12.5137 2.73377 11.6752 2.89525 11.3994 3.53874L10.0066 6.78872C8.86223 6.44967 7.57245 6.73154 6.66867 7.63532L5.59475 8.70925C5.36287 8.94112 5.36287 9.31706 5.59474 9.54893L7.29031 11.2445L2.74678 15.788C2.51491 16.0199 2.51491 16.3958 2.74678 16.6277C2.97865 16.8596 3.3546 16.8596 3.58647 16.6277L8.13 12.0842L9.82561 13.7798C10.0575 14.0117 10.4334 14.0117 10.6653 13.7798L11.7392 12.7059C12.643 11.8021 12.9249 10.5123 12.5858 9.36797L15.8358 7.97512C16.4793 7.69934 16.6408 6.86085 16.1457 6.36581L13.0087 3.22882Z",
    fill: "#327099"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.c509a3a2c6533bfcfaf0c4b2ff6fc801.svg";
export { ForwardRef as ReactComponent };